export default __webpack_public_path__ + "static/project-slide-2-2016-765-d16bb774341cafd85569c004160760b1.jpg";